import { Component } from '@angular/core';

@Component({
  selector: 'app-aesthetics',
  templateUrl: './aesthetics.component.html',
  styleUrls: ['./aesthetics.component.css']
})
export class AestheticsComponent {

}
